import { Core, Decorative } from "@faire/design-tokens";
import { trackBrandLeadsBrandsPageGeographicMapView } from "@faire/web-api/events/brandLeads/view/brandsPageGeographicMap";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React from "react";
import styled from "styled-components";

// eslint-disable-next-line import/no-unassigned-import
import "@faire/retailer/components/slick.css";

import { GeographicMapDesktop } from "./GeographicMapDesktop";
import { GeographicMapMobile } from "./GeographicMapMobile";

type Props = {
  showCaseStudies?: boolean;
};

export const GeographicMap: React.FC<Props> = ({ showCaseStudies }) => {
  const { isMobile } = useViewport();
  const ref = useDoActionWhenVisible(
    trackBrandLeadsBrandsPageGeographicMapView
  );
  return (
    <WhenVisibilityIsImminent>
      <Container ref={ref} $showCaseStudies={showCaseStudies}>
        {isMobile ? <GeographicMapMobile /> : <GeographicMapDesktop />}
      </Container>
    </WhenVisibilityIsImminent>
  );
};

const Container = styled(Column)<{
  $showCaseStudies?: boolean;
}>`
  width: 100%;
  background-color: ${({ $showCaseStudies }) =>
    $showCaseStudies ? Core.surface.inverse : Decorative.tint.neutral};
  padding: ${getSpacing("8x")};

  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("3x", 0)};
    background-color: ${Core.surface.inverse};
  }
`;
